import React from 'react';
import { Clock3 as Clock3Icon, Dumbbell as DumbbellIcon, HeartPulse as HeartPulseIcon, Sparkles as SparklesIcon } from 'lucide-react';
const benefits = [{
  icon: HeartPulseIcon,
  title: 'Blood sugar friendly',
  text: 'Every recipe avoids the blood sugar spikes that leave you tired, cranky, and hungry by 10am.'
}, {
  icon: DumbbellIcon,
  title: 'Higher in protein',
  text: 'Naturally protein-rich options to support muscle health and keep you full for hours.'
}, {
  icon: Clock3Icon,
  title: 'Under 10 minutes',
  text: 'Designed for busy mornings. Most recipes are faster than waiting for toast to pop.'
}, {
  icon: SparklesIcon,
  title: 'Actually delicious',
  text: 'Tested and approved by real women. Because healthy food should taste good too.'
}];
export function BenefitsSection() {
  return <section className="bg-forest py-20 text-cream sm:py-24" data-id="element-11" data-mp="xy4vbrt50igt">
      <div className="mx-auto max-w-6xl px-5 lg:px-8" data-id="element-12" data-mp="12yk4e76dz3sz">
        <div className="mx-auto max-w-3xl text-center" data-id="element-13" data-mp="2bexlj83c2wvb">
          <p className="text-sm font-bold uppercase tracking-[0.16em] text-sage" data-id="element-14" data-mp="2bdcrdjkxlfxz">
            The solution
          </p>
          <h2 className="mt-3 font-serif text-4xl leading-tight sm:text-5xl" data-id="element-15" data-mp="27brehy8ed1ns">
            A 21-day breakfast reset made for your body —{' '}
            <em className="text-sage" data-id="element-16" data-mp="2g6xeggkzkpie">not a 30-year-old&apos;s.</em>
          </h2>
          <p className="mt-5 text-lg leading-8 text-cream/75" data-id="element-17" data-mp="1sfry80b4vv7k">
            The Bread-Free Breakfast Plan for Women in Menopause — More Energy,
            Less Bloating, Flatter Belly.
          </p>
        </div>
        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-18" data-mp="22er8fnbjrywo">
          {benefits.map(({
          icon: Icon,
          title,
          text
        }) => <article key={title} className="rounded-2xl border border-cream/15 bg-white/5 p-6" data-id="element-19" data-mp="1xe38gc5cc7qb">
              <Icon size={26} className="text-terracotta" data-id="element-20" data-mp="38utkibwg3tru" />
              <h3 className="mt-5 text-lg font-extrabold" data-id="element-21" data-mp="38ubggt3jkb9d">{title}</h3>
              <p className="mt-2 text-sm leading-6 text-cream/70" data-id="element-22" data-mp="3gu7otna1nng9">{text}</p>
            </article>)}
        </div>
      </div>
    </section>;
}